/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserOrganizationResponse
 */
export interface UserOrganizationResponse {
    /**
     * 
     * @type {string}
     * @memberof UserOrganizationResponse
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserOrganizationResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserOrganizationResponse
     */
    note?: string | null;
    /**
     * 
     * @type {any}
     * @memberof UserOrganizationResponse
     */
    organizationId?: any | null;
}

/**
 * Check if a given object implements the UserOrganizationResponse interface.
 */
export function instanceOfUserOrganizationResponse(value: object): value is UserOrganizationResponse {
    return true;
}

export function UserOrganizationResponseFromJSON(json: any): UserOrganizationResponse {
    return UserOrganizationResponseFromJSONTyped(json, false);
}

export function UserOrganizationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserOrganizationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] === undefined ? undefined : json['code'] === null ? null : json['code'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'note': json['note'] === undefined ? undefined : json['note'] === null ? null : json['note'],
        'organizationId': json['organizationId'] === undefined ? undefined : json['organizationId'] === null ? null : json['organizationId'],
    };
}

export function UserOrganizationResponseToJSON(json: any): UserOrganizationResponse {
    return UserOrganizationResponseToJSONTyped(json, false);
}

export function UserOrganizationResponseToJSONTyped(value?: UserOrganizationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'note': value['note'],
        'organizationId': value['organizationId'],
    };
}

